import { formatCurrency } from "../../../../Utils/utils"
import { formatCount } from "../Table/columns"

const OPERATOR_SYMBOLS = { is_equal_to: "=", is_greater_than: ">", is_less_than: "<" }

const formatPercent = (value) => `${value}%`
const formatDollars = (value) => formatCurrency(value, Number.isInteger(value))

const countFilter = (id, label) => ({
  id,
  label,
  title: `Filter by ${label.toLowerCase()}`,
  type: "whole_number",
  min: 0,
  formatValue: formatCount
})

const FRAUD_COUNT = countFilter("fraud_count", "Fraud count")
const DISPUTE_COUNT = countFilter("dispute_count", "Dispute count")
const TRANSACTION_COUNT = countFilter("transaction_count", "Transaction count")
const TRANSACTION_VOLUME = {
  id: "transaction_volume",
  label: "Transaction volume",
  title: "Filter by transaction volume",
  type: "number",
  min: 0,
  precision: 2,
  formatValue: formatDollars
}

export const VAMP_EPS_FILTERS = {
  vamp_rate: {
    id: "vamp_rate",
    label: "VAMP ratio",
    title: "Filter by VAMP ratio",
    type: "number",
    min: 0,
    precision: 2,
    formatValue: formatPercent
  },
  fraud_count: FRAUD_COUNT,
  dispute_count: DISPUTE_COUNT,
  transaction_count: TRANSACTION_COUNT,
  transaction_volume: TRANSACTION_VOLUME
}

export const MC_EPS_FILTERS = {
  fraud_count: FRAUD_COUNT,
  dispute_count: DISPUTE_COUNT,
  transaction_count: TRANSACTION_COUNT,
  transaction_volume: TRANSACTION_VOLUME
}

export const EPS_FILTER_ICONS = {}

export const getEmptyEpsFilters = (filtersMap) =>
  Object.fromEntries(
    Object.keys(filtersMap).map((key) => [key, { min: null, max: null, type: null }])
  )

export const hasActiveEpsFilters = (filters) =>
  Object.values(filters || {}).some((filter) => filter?.type)

export const toEpsFilterParams = (filters) =>
  Object.fromEntries(
    Object.entries(filters || {})
      .filter(([, filter]) => filter?.type)
      .map(([key, { type, min, max }]) => [
        key,
        type === "is_between" ? `${min},${max}` : `${OPERATOR_SYMBOLS[type]} ${min}`
      ])
  )
